//English
let dialogEducationFirstEn = [
  {
    char:"Stacy",  position:"center",
    phrases:[
      {text:"Yes, right here"},
      {text:"Now move it like I showed you"},
      {animationStart:true, animationSpeed:10},
      {text:"Yep, that's it"},
      {text:"But.."},
      {text:"Feels like it's a bit too intense for now..."},
    ]
  },
  {
    char:"Prof. Ryder",  position:"right",
    phrases:[
      {text:"<i>Richard, try doing it a little slower</i>", wait:1000, rangeAppears:true},
    ]
  },
];
let dialogEducationEn = [
  {
    char:"Stacy",  position:"center",
    phrases:[
      {text:"Okay, let's try one more time"},
      {text:"I am ready"},
      {animationStart:true, animationSpeed:10},
      {text:"Uh-huh"},
      {text:"But, feels like it's a bit too intense for now..."},
    ]
  },
  {
    char:"Prof. Ryder",  position:"right",
    phrases:[
      {text:"<i>Very good, now try doing it a little slower</i>", wait:1000, rangeAppears:true},
    ]
  },
];
let dialogEducationSkipEn = [
  {
    char:"Stacy",  position:"center",
    phrases:[
      {text:"Okay, let's try one more time"},
      {text:"I am ready"},
      {animationStart:true, animationSpeed:5},
      {text:"Yeah, that's it"},
      {text:"<i>Now, try doing it a little faster</i>", wait:1000, interfaceAppears:true}
    ]
  },
];

//Russian
let dialogEducationFirstRu = [
  {
    char:"Стейси",  position:"center",
    phrases:[
      {text:"Ага, вот тут"},
      {text:"А теперь двигай рукой как я тебе показывала"},
      {animationStart:true, animationSpeed:10},
      {text:"Ага, вот так"},
      {text:"Только.."},
      {text:"Не так интенсивно.."},
    ]
  },
  {
    char:"Мисс Райдер",  position:"right",
    phrases:[
      {text:"<i>Ричард, попробуй сбавить скорость</i>", wait:1000, rangeAppears:true},
    ]
  },
];
let dialogEducationRu = [
  {
    char:"Стейси",  position:"center",
    phrases:[
      {text:"Окей, давай попробуем еще разок"},
      {text:"Можешь начинать.."},
      {animationStart:true, animationSpeed:10},
      {text:"Ах"},
      {text:"Пожалуйста, чуть нежнее..."},
    ]
  },
  {
    char:"Мисс Райдер",  position:"right",
    phrases:[
      {text:"<i>Очень хорошо, только чуть помедленнее</i>", wait:1000, rangeAppears:true},
    ]
  },
];
let dialogEducationSkipRu = [
  {
    char:"Стейси",  position:"center",
    phrases:[
      {text:"Окей, давай попробуем еще разок"},
      {text:"Можешь начинать.."},
      {animationStart:true, animationSpeed:5},
      {text:"Ага, вот так"},
      {text:"<i>Можно даже немного быстрее</i>", wait:1000, interfaceAppears:true}
    ]
  },
];

//FIRST stage

//English
let lowerSpeedArrEn=[
[{
  char:"Stacy",  position:"center",
  phrases:[
    {text:"Yeah"},
    {text:"This speed is perfect for now"},
    {text:"Mhmm"},
    {text:"Your hands feel so soft..."},
    {text:"I like it"},
  ]
},
{
  char:"Prof. Ryder",  position:"right",
  phrases:[
    {text:"Richard, you are doing great!", stageComplete:true},
    {text:"Keep it up!"},
    {text:"Please, keep in mind that"},
    {text:"These movements might not be very familiar to your hand"},
    {text:"So try to listen to Stacy, but don’t go too fast, or you'll get tired and have to start over!", staminaAppear:true, wait:1000},
    {text:"Сonsistency of stimulation is very important to achieve an orgasm!"},
  ]
},
{
  char:"Stacy",  position:"center",
  phrases:[
    {text:"<i>You can do it a little faster now</i>", nextStage:true, wait:1000},
  ]
},
],
[{
  char:"Stacy",  position:"center",
  phrases:[
    {text:"OH GOD!", vibration:[700]},
    {text:"It's too much!!"},
    {text:"I need a good warm up before something like this!"},
    {text:"AH!"},
    {text:"Do it sloOower!!"},
    {text:"PLEASE..."},
    {text:"IT ALMOST HURTS!!", wait:1000},
    {text:"Just... do it as slow as you caAAN", wait:1000, checkPoint:true},
  ]
}
],
[{
  char:"Stacy",  position:"center",
  phrases:[
    {text:"Uh-huh, a bit slower"},
    {text:"You're almost there"},
    {text:"Just a little slower"},
    {text:"I like when it starts slow"},
    {text:"Even slower"},
    {text:"Aghhh...", vibration:[700], wait:500},
    {text:"DICK!"},
    {text:"It feels like a torture!", wait:1000},
    {text:"Do it as slow as you can", wait:1000, checkPoint:true},

  ]
}
],
[
  {
    char:"Prof. Ryder",  position:"right",
    phrases:[
      {text:"Richard, please, listen to Stacy"},
      {text:"Or I'll have to stop it"},
      {text:"Richard, my last warning!", vibration:[100,50,100], wait:1500},
      {text:"All right, let's make a pause here", badEnd:true},
    ]
  }
],
[
  {
    char:"Stacy",  position:"center",
    phrases:[
      {text:"Oh, seems like something changed...", wait:500},
      {text:"Сan you please do as you did before?", wait:1500},
    ]
  },
  {
    char:"Prof. Ryder",  position:"right",
    phrases:[
      {text:"Richard, are you here?", vibration:[100,50,100], wait:1000},
      {text:"All right, let's make a pause here", badEnd:true},
    ]
  }

]
];

//Russian
let lowerSpeedArrRu=[
[{
  char:"Стейси",  position:"center",
  phrases:[
    {text:"Угу"},
    {text:"Вот так вот"},
    {text:"Ммм-хммм"},
    {text:"У тебя такие нежные руки..."},
    {text:"Это очень приятно.."},
  ]
},
{
  char:"Мисс Райдер",  position:"right",
  phrases:[
    {text:"Ричард, ты молодец!", stageComplete:true},
    {text:"Так держать!"},
    {text:"Но не забывай"},
    {text:"Тебе нужно время чтобы привыкнуть к таким движениям"},
    {text:"Так что старайся слушать Стейси, но и не переусердствуй, а то устанешь и придется начать все сначала!", staminaAppear:true, wait:1000},
    {text:"Тут очень важно постоянство!"},
  ]
},
{
  char:"Стейси",  position:"center",
  phrases:[
    {text:"<i>Теперь можешь немного ускориться</i>", nextStage:true, wait:1000},
  ]
},
],
[{
  char:"Стейси",  position:"center",
  phrases:[
    {text:"БОЖЕ!", vibration:[700]},
    {text:"Это слишком быстро!!"},
    {text:"Для такого мне нужна предварительная подготовка..."},
    {text:"АХ!"},
    {text:"Давай ПомееедлЕнеЕее!!"},
    {text:"ПОЖАЛУЙСТА..."},
    {text:"МНЕ НЕПРИЯТНО!!", wait:1000},
    {text:"ПожаАлуйтса, просто... замедлись", wait:1000, checkPoint:true},
  ]
}
],
[{
  char:"Стейси",  position:"center",
  phrases:[
    {text:"Ага, немного медленнее"},
    {text:"Еще немного.."},
    {text:"Чуть-чуть помедленнее"},
    {text:"Мне приятно, когда начинают медленно"},
    {text:"Еще медленнее"},
    {text:"Аргххх...", vibration:[700], wait:500},
    {text:"ДИИК!"},
    {text:"Хватит меня дразнить!", wait:1000},
    {text:"Двигай рукой максимально медленно", wait:1000, checkPoint:true},

  ]
}
],
[
  {
    char:"Мисс Райдер",  position:"right",
    phrases:[
      {text:"Ричард, пожалуйста, слушай, что говорит Стейси"},
      {text:"Иначе нам придется остановиться"},
      {text:"Ричард, мое последнее предупреждение!", vibration:[100,50,100], wait:1500},
      {text:"Так, ладно, давайте сделаем перерыв", badEnd:true},
    ]
  }
],
[
  {
    char:"Стейси",  position:"center",
    phrases:[
      {text:"Ох, кажется, что-то поменялось...", wait:500},
      {text:"Можешь делать как раньше?", wait:1500},
    ]
  },
  {
    char:"Мисс Райдер",  position:"right",
    phrases:[
      {text:"Ричард, ты тут?", vibration:[100,50,100], wait:1000},
      {text:"Ладно, я думаю, стоит сделать перерыв", badEnd:true},
    ]
  }

]
];

//SECOND stage

//English
let secondStageArrEn=[
  [{
    char:"Stacy",  position:"center",
    phrases:[
      {text:"Yes, yes, yes!"},
      {text:"Just like that"},
      {text:"Oh my god"},
      {text:"It feels so good"},
      {text:"Mmmm", wait:500},
      {text:"Yeeaah"},
    ]
  },
  {
    char:"Prof. Ryder",  position:"right",
    phrases:[
      {text:"Oh, I can see you like it, Stacy", stageComplete:true},
      {text:"And Richard too...", wait:500},
      {text:"Do you want it faster?", wait:1000},
    ]
  },
  {
    char:"Stacy",  position:"center",
    phrases:[
      {text:"Shit...", wait:500},
      {text:"Sorry, I think I just spaced out..."},
    ]
  },
  {
    char:"Prof. Ryder",  position:"right",
    phrases:[
      {text:"Oh, don't worry, darling, it's completely okay"},
      {text:"You can try making eye contact with me", wait:500},
      {text:"It'll help you concentrate on what's happening right now", wait:1000},
      {text:"Yes, very good, try not to look away...", wait:1000},
      {text:"And don't forget to guide Richard"},
    ]
  },
  {
    char:"Stacy",  position:"center",
    phrases:[
      {text:"<i>Could you do it a little slower again?</i>",  wait:1000, nextStage:true},
    ]
  },
  ],
  [{
    char:"Stacy",  position:"center",
    phrases:[
      {text:"Oh god!"},
      {text:"That's intense!"},
      {text:"You better save your energy for the end"},
      {text:"I'm not..."},
      {text:"Mmmph"},
      {text:"Ready for something like this yet.."},
      {text:"Do it slower"},
      {text:"AH!", vibration:[700]},
      {text:"Please"},
      {text:"Listen to me"},
      {text:"Just... do it slower", wait:1000, checkPoint:true},
    ]
  }
  ],
[{
  char:"Stacy",  position:"center",
  phrases:[
    {text:"Please speed up a little..."},
    {text:"It's too slow for now"},
    {text:"I usually like a bit of teasing...", wait:500},
    {text:"But now I want it faster so much!"},
    {text:"Pleeeease"},
    {text:"Faster"},
    {text:"I don't think I'm gonna cum this century if you continue like this...", wait:1000, checkPoint:true},
  ]
},
],
[
  {
    char:"Prof. Ryder",  position:"right",
    phrases:[
      {text:"Richard, please, listen to Stacy"},
      {text:"Or I'll have to stop it"},
      {text:"Richard, my last warning!", vibration:[100,50,100], wait:1500},
      {text:"All right, let's make a pause here", badEnd:true},
    ]
  }
],
[
  {
    char:"Stacy",  position:"center",
    phrases:[
      {text:"Oh, seems like something changed...", wait:500},
      {text:"Сan you please do as you did before?", wait:1500},
    ]
  },
  {
    char:"Prof. Ryder",  position:"right",
    phrases:[
      {text:"Richard, are you here?", vibration:[100,50,100], wait:1000},
      {text:"All right, let's make a pause here", badEnd:true},
    ]
  }

],
];

//Russian
let secondStageArrRu=[
  [{
    char:"Стейси",  position:"center",
    phrases:[
      {text:"Да-да-да!"},
      {text:"Вот так"},
      {text:"Господи..."},
      {text:"Как же приятно"},
      {text:"Ммм-хммм", wait:500},
      {text:"Агааа..."},
    ]
  },
  {
    char:"Мисс Райдер",  position:"right",
    phrases:[
      {text:"Оу, Стейси, вижу, тебе начинает это нравится", stageComplete:true},
      {text:"И Ричарду, кажется, тоже...", wait:500},
      {text:"Может ускоримся?", wait:1000},
    ]
  },
  {
    char:"Стейси",  position:"center",
    phrases:[
      {text:"Блин...", wait:500},
      {text:"Простите, я.. что-то задумалась..."},
    ]
  },
  {
    char:"Мисс Райдер",  position:"right",
    phrases:[
      {text:"Не переживай, дорогая, все хорошо"},
      {text:"Попробуй смотреть мне в глаза", wait:500},
      {text:"Это поможет тебе сконцентрироваться", wait:1000},
      {text:"Даа, вот так вот...", wait:1000},
      {text:"И не забывай говорить с Ричардом"},
    ]
  },
  {
    char:"Стейси",  position:"center",
    phrases:[
      {text:"<i>Можешь опять немного помедленнее, пожалуйста?</i>",  wait:1000, nextStage:true},
    ]
  },
  ],
  [{
    char:"Стейси",  position:"center",
    phrases:[
      {text:"АХ!"},
      {text:"Это слишком!"},
      {text:"Лучше побереги силы"},
      {text:"Я не..."},
      {text:"Ммммм"},
      {text:"Готова для такого сейчас.."},
      {text:"Медленнее"},
      {text:"АХ!", vibration:[700]},
      {text:"Пожалуйста"},
      {text:"Дик"},
      {text:"Просто... делай это помедленнее", wait:1000, checkPoint:true},
    ]
  }
  ],
[{
  char:"Стейси",  position:"center",
  phrases:[
    {text:"Пожалуйста, чуть быстрее..."},
    {text:"Это слишком медленно"},
    {text:"Обычно мне нравится, когда меня немного дразнят...", wait:500},
    {text:"Но сейчас я  ОЧЕНЬ хочу кончить!"},
    {text:"Пожааааалуйста"},
    {text:"Побыстрее"},
    {text:"Не думаю, что кончу в этом году, если ты и дальше будешь так делать...", wait:1000, checkPoint:true},
  ]
},
],
[
  {
    char:"Мисс Райдер",  position:"right",
    phrases:[
      {text:"Ричард, пожалуйста, слушай, что говорит Стейси"},
      {text:"Иначе нам придется остановиться"},
      {text:"Ричард, мое последнее предупреждение!", vibration:[100,50,100], wait:1500},
      {text:"Так, ладно, давайте сделаем перерыв", badEnd:true},
    ]
  }
],
[
  {
    char:"Стейси",  position:"center",
    phrases:[
      {text:"Ох, кажется, что-то поменялось...", wait:500},
      {text:"Можешь делать как раньше?", wait:1500},
    ]
  },
  {
    char:"Мисс Райдер",  position:"right",
    phrases:[
      {text:"Ричард, ты тут?", vibration:[100,50,100], wait:1000},
      {text:"Ладно, я думаю, стоит сделать перерыв", badEnd:true},
    ]
  }

],
];

//THRID stage

//English

let thirdStageArrEn=[
  [{
    char:"Stacy",  position:"center",
    phrases:[
      {text:"Yeah"},
      {text:"Right here"},
      {text:"Mmmhm", wait:500},
    ]
  },
  {
    char:"Prof. Ryder",  position:"right",
    phrases:[
      {text:"Yes, keep doing that, Richard", stageComplete:true},
      {text:"Your hand can rest for a bit now!"},
      {text:"Oh, I can see you want it so much, don't you, Stacy?", wait:500},
    ]
  },
  {
    char:"Stacy",  position:"center",
    phrases:[
      {text:"Uh-huuUH"},
      {text:"He's making me so wet..."},
    ]
  },
  {
    char:"Prof. Ryder",  position:"right",
    phrases:[
      {text:"<i>Okay, Richard, now try doing it as fast as you can</i>", wait:1000, nextStage:true},
    ]
  },
],
  [{
    char:"Stacy",  position:"center",
    phrases:[
      {text:"Aagh!"},
      {text:"It's too fast!!"},
      {text:"I want it slower"},
      {text:"GOD!"},
      {text:"DO IT SLOWER!!"},
      {text:"RICHARD PLEASE", vibration:[700]},
      {text:"IT ALMOST HURTS!!!", wait:1000, checkPoint:true},
    ]
  }
  ],
[{
  char:"Stacy",  position:"center",
  phrases:[
    {text:"You're almost there"},
    {text:"A bit slower", wait:1000},
    {text:"Please"},
    {text:"Not so fast"},
    {text:"Do it a little slower"},
    {text:"Dick, are you here?", wait:1000, checkPoint:true},
  ]
},
],
[{
  char:"Stacy",  position:"center",
  phrases:[
    {text:"It's a bit too slow"},
    {text:"A little faster", wait:1000},
    {text:"I can barely feel it now"},
    {text:"Please do it faster"},
    {text:"Dick, are you here?", wait:1000, checkPoint:true},
  ]
},
],
[
  {
    char:"Prof. Ryder",  position:"right",
    phrases:[
      {text:"Richard, listen to Stacy"},
      {text:"Or I'll have to stop it", wait:1500},
      {text:"Richard, my last warning!", vibration:[100,50,100], wait:1000},
      {text:"All right, let's make a pause here", badEnd:true},
    ]
  }
],
[
  {
    char:"Stacy",  position:"center",
    phrases:[
      {text:"Oh, seems like something changed...", wait:500},
      {text:"Сan you please do as you did before?", wait:1500},
    ]
  },
  {
    char:"Prof. Ryder",  position:"right",
    phrases:[
      {text:"Richard, are you here?", vibration:[100,50,100], wait:1000},
      {text:"All right, let's make a pause here", badEnd:true},
    ]
  }
]
];

//Russian
let thirdStageArrRu=[
  [{
    char:"Стейси",  position:"center",
    phrases:[
      {text:"Да"},
      {text:"Вот так вот.."},
      {text:"Угу-у-у", wait:500},
    ]
  },
  {
    char:"Мисс Райдер",  position:"right",
    phrases:[
      {text:"Очень хорошо, Ричард...", stageComplete:true},
      {text:"Как раз дашь руке немного отдохнуть"},
      {text:"Оу, я смотрю, ты вся в нетерпении, да, Стейси?", wait:500},
    ]
  },
  {
    char:"Стейси",  position:"center",
    phrases:[
      {text:"Ммм-хммм"},
      {text:"Я так этого хочу..."},
    ]
  },
  {
    char:"Мисс Райдер",  position:"right",
    phrases:[
      {text:"<i>Хорошо, Ричард, теперь попробуй  максимально ускориться</i>", wait:1000, nextStage:true},
    ]
  },
],
  [{
    char:"Стейси",  position:"center",
    phrases:[
      {text:"Ааргх!"},
      {text:"Слишком быстро!!"},
      {text:"Помедленнее"},
      {text:"БЛИН!"},
      {text:"МЕДЛЕННЕЕ!!"},
      {text:"ДИК, ПОЖАЛУЙСТА", vibration:[700]},
      {text:"МНЕ БОЛЬНО!!!", wait:1000, checkPoint:true},
    ]
  }
  ],
[{
  char:"Стейси",  position:"center",
  phrases:[
    {text:"Угу, почти"},
    {text:"Только немного помедленнее", wait:1000},
    {text:"Пожалуйста.."},
    {text:"Не так быстро"},
    {text:"Еще медленнее"},
    {text:"Дик, ты тут?", wait:1000, checkPoint:true},
  ]
},
],
[{
  char:"Стейси",  position:"center",
  phrases:[
    {text:"Это слишком медленно"},
    {text:"Чуть побыстрее", wait:1000},
    {text:"Я почти ничего не чувствую"},
    {text:"Пожалуйста, побыстрее"},
    {text:"Дик, ты тут?", wait:1000, checkPoint:true},
  ]
},
],
[
  {
    char:"Мисс Райдер",  position:"right",
    phrases:[
      {text:"Ричард, пожалуйста, слушай, что говорит Стейси"},
      {text:"Иначе нам придется остановиться"},
      {text:"Ричард, мое последнее предупреждение!", vibration:[100,50,100], wait:1500},
      {text:"Так, ладно, давайте сделаем перерыв", badEnd:true},
    ]
  }
],
[
  {
    char:"Стейси",  position:"center",
    phrases:[
      {text:"Ох, кажется, что-то поменялось...", wait:500},
      {text:"Можешь делать как раньше?", wait:1500},
    ]
  },
  {
    char:"Мисс Райдер",  position:"right",
    phrases:[
      {text:"Ричард, ты тут?", vibration:[100,50,100], wait:1000},
      {text:"Ладно, я думаю, стоит сделать перерыв", badEnd:true},
    ]
  }

],
];

//FOURTH stage

//English
let fourthStageArrEn=[
  [
  {
    char:"Prof. Ryder",  position:"right",
    phrases:[
      {text:"Yes, very good", wait:800, stageComplete:true},
      {text:"<i>And now slow down to the lowest speed</i>", wait:1500, nextStage:true},
    ]
  },
],
[
  {
    char:"Prof. Ryder",  position:"right",
    phrases:[
      {text:"Richard?"},
      {text:"Try doing it as fast as you can", vibration:[100,50,100], wait:1500},
      {text:"Richard, are you here?", badEnd:true},
    ]
  }
]
];

//Russian
let fourthStageArrRu=[
  [
  {
    char:"Мисс Райдер",  position:"right",
    phrases:[
      {text:"Вот так, очень хорошо!", wait:800, stageComplete:true},
      {text:"<i>А теперь максимально замедлиться</i>", wait:1500, nextStage:true},
    ]
  },
],
[
  {
    char:"Мисс Райдер",  position:"right",
    phrases:[
      {text:"Ричард?"},
      {text:"Постарайся двигаться так быстро, как только можешь", vibration:[100,50,100], wait:1500},
      {text:"Ричард, ты здесь?", badEnd:true},
    ]
  }
]
];

//FIFTH stage

//English
let fifthStageArrEn=[
  [
  {
    char:"Prof. Ryder",  position:"right",
    phrases:[
      {text:"Uh-huh", wait:800, stageComplete:true},
      {text:"Okay, now... umm", wait:1000},
      {text:"Let me show you", wait:500, guideStart:true},
      {text:"Just like that, speeding up and slowing down, speeding up and slowing down", wait:1000},
      {text:"Very good!", wait:1000, guideFinish:true},
      {text:"<i>Keep moving like that really fast, speed up and then slow down and so on</i>", wait:1500, nextStage:true},
    ]
  },
],
[
  {
    char:"Prof. Ryder",  position:"right",
    phrases:[
      {text:"Slow down, please"},
      {text:"Try doing it as slow as you can", vibration:[100,50,100], wait:1500},
      {text:"Richard, are you here?", badEnd:true},
    ]
  }
]
];

//Russian
let fifthStageArrRu=[
  [
  {
    char:"Мисс Райдер",  position:"right",
    phrases:[
      {text:"Ага-а-а", wait:800, stageComplete:true},
      {text:"Хорошо... Так, теперь.. ммм", wait:1000},
      {text:"Дай-ка я тебе покажу", wait:500, guideStart:true},
      {text:"Вот так, ускоряешься и замедляешься, ускоря-я-яешься... И-и-и замедля-я-яешься..", wait:1000},
      {text:"Умница!", wait:1000, guideFinish:true},
      {text:"<i>Продолжай чередовать скорость, ускоряйся, затем замедляйся и так далее</i>", wait:1500, nextStage:true},
    ]
  },
],
[
  {
    char:"Мисс Райдер",  position:"right",
    phrases:[
      {text:"Пожалуйста, замедлись"},
      {text:"Постарайся двигаться так медленно, как только можешь", vibration:[100,50,100], wait:1500},
      {text:"Ричард, ты здесь?", badEnd:true},
    ]
  }
]
];

//SIXTH STAGE

//English
let sixthStageArrEn=[
[
  {
    char:"Prof. Ryder",  position:"right",
    phrases:[
      {text:"Yes"},
      {text:"Very good", wait:500},
      {text:"Keep going"},
      {text:"Do you like it, Stacy?", wait:500},
    ]
  },
  {
    char:"Stacy",  position:"center",
    phrases:[
      {text:"Mhmm", wait:500},
      {text:"I like it, Ms. Ryder"},
      {text:"Please don't stop!"},
      {text:"Uhhh"},
      {text:"I wanna cum so bad"},
      {text:"Oh my god!", wait:500},
      {text:"GOOOD!", vibration:[700]},
      {text:"I LIKE IT SO MUCH"},
      {text:"AAAHH"},
      {text:"I'M GETTING CLOSER", wait:500},
      {text:"MMMMMMPH"},
      {text:"I'M SO CLOOSE!", vibration:[300, 100, 500]},
      {text:"<i>NOW KEEP THE SPEED ON MAXIMUM</i>", wait:1000, nextStage:true},
    ]
  },
],
[
  {
    char:"Prof. Ryder",  position:"right",
    phrases:[
      {text:"You're doing it right, but a bit too slow, try doing it faster"},
      {text:"<i>Richard, you should change the speed a little faster, from low to high and so on</i>", wait:1000},
    ]
  },
  {
    char:"Stacy",  position:"center",
    phrases:[
      {text:"Dick, please do it a bit faster!", vibration:[100,50,100], wait:1000},
    ]
  },
  {
    char:"Prof. Ryder",  position:"right",
    phrases:[
      {text:"Richard, are you here?", badEnd:true},
    ]
  },
],
[
  {
    char:"Prof. Ryder",  position:"right",
    phrases:[
      {text:"Please, keep doing as I showed you"},
      {text:"<i>Keep changing the speed from slow to fast and so on</i>", wait:1000},
    ]
  },
  {
    char:"Stacy",  position:"center",
    phrases:[
      {text:"Dick, please don't stop!", vibration:[100,50,100], wait:1000},
    ]
  },
  {
    char:"Prof. Ryder",  position:"right",
    phrases:[
      {text:"Richard, are you here?", badEnd:true},
    ]
  },
]
];

//Russian
let sixthStageArrRu=[
[
  {
    char:"Мисс Райдер",  position:"right",
    phrases:[
      {text:"Да-а-а"},
      {text:"Суупер", wait:500},
      {text:"Продолжаай..."},
      {text:"Тебе приятно так, Стейси?", wait:500},
    ]
  },
  {
    char:"Стейси",  position:"center",
    phrases:[
      {text:"Ммм-хмм", wait:500},
      {text:"Мне очень приятно, мисс Райдер"},
      {text:"Пожалуйста, Дик, только не останавливайся!"},
      {text:"Аа-а-аххх"},
      {text:"Я так хочу ко-о-ончить.."},
      {text:"Господи!", wait:500},
      {text:"бля-Я-яЯТЬ!", vibration:[700]},
      {text:"КАК ЖЕ ХОРОШО"},
      {text:"АААААХхХ"},
      {text:"Я УЖЕ ПОЧТИ", wait:500},
      {text:"ММММММПХХ"},
      {text:"Я ОЧЕНЬ БЛИЗКО!", vibration:[300, 100, 500]},
      {text:"<i>ДВИГАЙСЯ МАКСИМАЛЬНО БЫСТРО</i>", wait:1000, nextStage:true},
    ]
  },
],
[
  {
    char:"Мисс Райдер",  position:"right",
    phrases:[
      {text:"Ты молодец, но ты делаешь это слишком медленно, постарайся ускорить темп"},
      {text:"<i>Ричард, меняй скорость немного быстрее</i>", wait:1000},
    ]
  },
  {
    char:"Стейси",  position:"center",
    phrases:[
      {text:"Дик, пожалуйста, немного быстрее!", vibration:[100,50,100], wait:1000},
    ]
  },
  {
    char:"Мисс Райдер",  position:"right",
    phrases:[
      {text:"Ричард, ты здесь?", badEnd:true},
    ]
  },
],
[
  {
    char:"Мисс Райдер",  position:"right",
    phrases:[
      {text:"Пожалуйста, попробуй делать, как я только что показала"},
      {text:"<i>Ричард, попробуй замедляться, а потом снова ускоряться и так далее</i>", wait:1000},
    ]
  },
  {
    char:"Стейси",  position:"center",
    phrases:[
      {text:"Дик, только не останавливайся!", vibration:[100,50,100], wait:1000},
    ]
  },
  {
    char:"Мисс Райдер",  position:"right",
    phrases:[
      {text:"Ричард, ты здесь?", badEnd:true},
    ]
  },
]
];

//FINAL STAGE

//English
let finalStageArrEn=[
  [
    {
      char:"Stacy",  position:"center",
      phrases:[
        {text:"YEEEEEEES!!!", vibration:[1000]},
        {text:"OH MY GOD!!", vibration:[300, 100, 500], wait:1000},
        {text:"JUST DON'T STOP"},
      ]
    },
    {
      char:"Prof. Ryder",  position:"right",
      phrases:[
        {text:"Do you feel her heat, Richard", wait:500},
        {text:"You made her so wet"},
      ]
    },
    {
      char:"Stacy",  position:"center",
      phrases:[
        {text:"AAAHh", wait:1500},
        {text:"I'M GONNA", vibration:[700], passed:true},
      ]
    },
    {
      char:"Prof. Ryder",  position:"right",
      phrases:[
        {text:"You're gonna"},
      ]
    },
    {
      char:"Stacy",  position:"center",
      phrases:[
        {text:"FUUUCK!", vibration:[100,50,100,50,100], wait:500},
        {text:"I'M..", vibration:[100,50,100,50,100], wait:1500},
        {text:"CUMMING!!", vibration:[100,50,150,50,200]},
        {text:"AAAAAHH", vibration:[700], wait:1000, nextStage:true},
      ]
    },
],
[
  {
    char:"Stacy",  position:"center",
    phrases:[
      {text:"NO NO NO NO NO!"},
      {text:"DO IT AS FAST AS YOU CAN", wait:500},
      {text:"PLEASE, I'M SO CLOSE..."},
      {text:"DON'T LET ME LOOSE IT!", vibration:[100,50,100], wait:1000},
      {text:"Fuck!", badEnd:true}
    ]
  },
]
];

//Russian
let finalStageArrRu=[
  [
    {
      char:"Стейси",  position:"center",
      phrases:[
        {text:"БОЖЕ-Е-Е!!!", vibration:[1000]},
        {text:"КАК ЖЕ ОХУЕННО!!", vibration:[300, 100, 500], wait:1000},
        {text:"ТОЛЬКО НЕ ОСТАНАВЛИВАЙСЯ"},
      ]
    },
    {
      char:"Мисс Райдер",  position:"right",
      phrases:[
        {text:"Чувствуешь, как она этого хочет, Ричард?", wait:500},
        {text:"Ты так хорошо постарался"},
      ]
    },
    {
      char:"Стейси",  position:"center",
      phrases:[
        {text:"АААаХх", wait:1500},
        {text:"Я СЕЙЧАС", vibration:[700], passed:true},
      ]
    },
    {
      char:"Мисс Райдер",  position:"right",
      phrases:[
        {text:"Ты сейчас"},
      ]
    },
    {
      char:"Стейси",  position:"center",
      phrases:[
        {text:"БЛЯЯЯЯТЬ!", vibration:[100,50,100,50,100], wait:500},
        {text:"Я сейчас..", vibration:[100,50,100,50,100], wait:1500},
        {text:"М-м-мпхпф!!", vibration:[100,50,150,50,200]},
        {text:"ААаААаАхХХ", vibration:[700], wait:1000, nextStage:true},
      ]
    },
],
[
  {
    char:"Стейси",  position:"center",
    phrases:[
      {text:"НЕТ НЕТ НЕТ!"},
      {text:"МАКСИМАЛЬНО БЫСТРО", wait:500},
      {text:"ПОЖАЛУЙСТА, Я ТАК БЛИЗКО..."},
      {text:"ТОЛЬКО НЕ ОСТАНАВЛИВАЙСЯ!", vibration:[100,50,100], wait:1000},
      {text:"Блять!", badEnd:true}
    ]
  },
]
];

export { dialogEducationFirstEn, dialogEducationEn, dialogEducationSkipEn, lowerSpeedArrEn, secondStageArrEn, thirdStageArrEn, fourthStageArrEn, fifthStageArrEn, sixthStageArrEn, finalStageArrEn, dialogEducationFirstRu, dialogEducationRu, dialogEducationSkipRu, lowerSpeedArrRu, secondStageArrRu, thirdStageArrRu, fourthStageArrRu, fifthStageArrRu, sixthStageArrRu, finalStageArrRu };
